import { BaseModel } from "model/BaseModel";
import AprovacaoFaixaValores from "./AprovacaoFaixaValores";

export default class AprovacaoFaixaValoresRotina implements BaseModel {

    id: number;
    codigo: string | null;
    tipoRotina: string;
    aprovacoes: AprovacaoFaixaValores[];

    constructor(
        id = 0,
        codigo = '',
        tipoRotina = '',
        aprovacoes: AprovacaoFaixaValores[] = [],
    ) {
        this.id = id;
        this.codigo = codigo;
        this.tipoRotina = tipoRotina;
        this.aprovacoes = aprovacoes;
    }
}
